import React, { Children, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StyledMarkdownBlock } from "../../../../components/CodeView";
import { highlight } from "../../../../utils/highlight";
import "./styles.less";

export const DocCode = ({
  title = "",
  code,
  lang = "javascript",
  extra = null,
}) => {
  const { t } = useTranslation();

  return (
    <div className="doc-code">
      {title && <div className="code-title">{title}</div>}
      <StyledMarkdownBlock
        dangerouslySetInnerHTML={{
          __html: highlight(code, lang),
        }}
      />
      {extra && <div className="code-extra">{extra}</div>}
    </div>
  );
};
